import { render } from "./HoursExceptions.vue?vue&type=template&id=5b22efd2"
import script from "./HoursExceptions.vue?vue&type=script&lang=js"
export * from "./HoursExceptions.vue?vue&type=script&lang=js"

import "./HoursExceptions.vue?vue&type=style&index=0&id=5b22efd2&lang=less"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__